// Roteador por hash: "#/rota?param=valor". Cada view monta no container e
// pode devolver uma função de limpeza. Rotas protegidas exigem sessão.
export interface RouteParams {
  query: URLSearchParams;
}
export type View = (root: HTMLElement, params: RouteParams) => void | (() => void);

export interface Route {
  view: View;
  /** exige usuário logado (redireciona para o login) */
  auth?: boolean;
  /** só para visitantes (logado vai para o menu) */
  guest?: boolean;
}

export function navigate(path: string): void {
  if (location.hash === `#${path}`) window.dispatchEvent(new HashChangeEvent("hashchange"));
  else location.hash = path;
}

export function createRouter(
  root: HTMLElement,
  routes: Record<string, Route>,
  fallback: string,
  isLoggedIn: () => boolean,
) {
  let cleanup: void | (() => void);
  const render = () => {
    const [rawPath = "", rawQuery = ""] = location.hash.replace(/^#/, "").split("?");
    const path = rawPath || fallback;
    const route = routes[path] ?? routes[fallback]!;
    if (route.auth && !isLoggedIn()) {
      navigate(`/entrar?voltar=${encodeURIComponent(path)}`);
      return;
    }
    if (route.guest && isLoggedIn()) {
      navigate("/menu");
      return;
    }
    if (typeof cleanup === "function") cleanup();
    root.replaceChildren();
    cleanup = route.view(root, { query: new URLSearchParams(rawQuery) });
    root.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  };
  window.addEventListener("hashchange", render);
  render();
}
